import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=cc676068&scoped=true&"
import script from "./Onboarding.vue?vue&type=script&setup=true&lang=js&"
export * from "./Onboarding.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc676068",
  null
  
)

export default component.exports